import React from 'react'
import { string } from 'prop-types'
import Image from '../Image'

class ContentFullImage extends React.PureComponent {
  render() {
    return (
      <Image
        resource={this.props.image}
        alt={this.props.alt}
        width="1440"
        imgWidth="100%"
      />
    )
  }
}

ContentFullImage.defaultProps = {
  image: '',
  alt: ''
}
ContentFullImage.propTypes = {
  image: string,
  alt: string
}

export default ContentFullImage
